import { useMemo } from "react";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyListQuery";
import {
	ArchivedFilterEnum,
	type ClientPropertyItemResponseDTO,
	type PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { PORTFOLIO_CONTRACT_STATE } from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import { useEffectivePortfolioFilter } from "web_myplann/Portfolio/Hooks/useEffectivePortfolioFilter";

type ContractStateLists = {
	isArchivedView: boolean;
	portfolioItems: PortfolioListItemResponseDTO[];
	propertyItems: ClientPropertyItemResponseDTO[];
	isLoading: boolean;
	isSuccess: boolean;
};

export const useContractStateLists = (): ContractStateLists => {
	const { filter } = useEffectivePortfolioFilter();
	const isArchivedView =
		filter.contractState === PORTFOLIO_CONTRACT_STATE.archived;
	const archivedFilter = isArchivedView
		? ArchivedFilterEnum.Archived
		: ArchivedFilterEnum.All;

	const portfolioQuery = usePortfolioListQuery(
		undefined,
		undefined,
		archivedFilter,
	);
	const propertyQuery = usePropertyListQuery(
		undefined,
		undefined,
		archivedFilter,
	);

	const portfolioItems = useMemo(
		() => portfolioQuery.data?.data ?? [],
		[portfolioQuery.data?.data],
	);
	const propertyItems = useMemo(
		() => propertyQuery.data?.data ?? [],
		[propertyQuery.data?.data],
	);

	return {
		isArchivedView,
		portfolioItems,
		propertyItems,
		isLoading: portfolioQuery.isLoading || propertyQuery.isLoading,
		isSuccess: portfolioQuery.isSuccess && propertyQuery.isSuccess,
	};
};
